import categoriesParser from "./categoriesParser";
export var itemObject = function itemObject(_ref) {
  var _ref$addon_selected = _ref.addon_selected,
      addon_selected = _ref$addon_selected === void 0 ? "" : _ref$addon_selected,
      _ref$affiliation = _ref.affiliation,
      affiliation = _ref$affiliation === void 0 ? "" : _ref$affiliation,
      _ref$byob_item = _ref.byob_item,
      byob_item = _ref$byob_item === void 0 ? "" : _ref$byob_item,
      _ref$coupon = _ref.coupon,
      coupon = _ref$coupon === void 0 ? "" : _ref$coupon,
      item_category = _ref.item_category,
      _ref$item_id = _ref.item_id,
      item_id = _ref$item_id === void 0 ? "" : _ref$item_id,
      _ref$item_list_id = _ref.item_list_id,
      item_list_id = _ref$item_list_id === void 0 ? "" : _ref$item_list_id,
      _ref$item_list_name = _ref.item_list_name,
      item_list_name = _ref$item_list_name === void 0 ? "" : _ref$item_list_name,
      _ref$item_name = _ref.item_name,
      item_name = _ref$item_name === void 0 ? "" : _ref$item_name,
      _ref$item_variant = _ref.item_variant,
      item_variant = _ref$item_variant === void 0 ? "" : _ref$item_variant,
      _ref$price = _ref.price,
      price = _ref$price === void 0 ? "" : _ref$price,
      _ref$quantity = _ref.quantity,
      quantity = _ref$quantity === void 0 ? "" : _ref$quantity,
      _ref$sku = _ref.sku,
      sku = _ref$sku === void 0 ? "" : _ref$sku,
      _ref$index = _ref.index,
      index = _ref$index === void 0 ? "" : _ref$index,
      _ref$reward_applied = _ref.reward_applied,
      reward_applied = _ref$reward_applied === void 0 ? "" : _ref$reward_applied;
  var defaultCategories = categoriesParser();
  return {
    addon_selected: addon_selected,
    affiliation: affiliation,
    byob_item: byob_item,
    coupon: coupon,
    index: index + 1,
    item_category: item_category ? item_category : defaultCategories,
    item_id: item_id,
    item_list_id: item_list_id,
    item_list_name: item_list_name,
    item_name: item_name,
    item_variant: item_variant,
    price: price,
    quantity: quantity,
    sku: sku,
    reward_applied: reward_applied
  };
};